export function getGlowColor(colorClass) {
  const colorMap = {
    'text-red-500': 'rgba(239, 68, 68, 1.0)',
    'text-blue-400': 'rgba(96, 165, 250, 1.0)',
    'text-orange-500': 'rgba(249, 115, 22, 1.0)',
    'text-blue-500': 'rgba(59, 130, 246, 1.0)',
    'text-green-500': 'rgba(34, 197, 94, 1.0)',
    'text-yellow-500': 'rgba(234, 179, 8, 1.0)',
    'text-emerald-300': 'rgba(52, 211, 153, 1.0)',
    'text-orange-300': 'rgba(251, 146, 60, 1.0)',
    'text-red-300': 'rgba(252, 165, 165, 1.0)',
    'text-blue-300': 'rgba(147, 197, 253, 1.0)',
    'text-green-300': 'rgba(134, 239, 172, 1.0)',
    'text-yellow-300': 'rgba(253, 224, 71, 1.0)',
  };
  return colorMap[colorClass] || 'rgba(249, 115, 22, 1.0)';
}

export function createGlowStyle(colorClass) {
  const glowColor = getGlowColor(colorClass);
  return `0 0 5px ${glowColor}, 0 0 10px ${glowColor}, 0 0 20px ${glowColor}, 0 0 30px ${glowColor}`;
}
